import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTheme } from '@/context/ThemeContext'
import { useProjectDetail } from '@/hooks/useProjectDetail'
import Footer from '@/components/Frontside/Footer'
import ProjectDetailRich from '@/components/project-detail/ProjectDetailRich'
import { normalizePortfolioProject } from '@/lib/projectDisplay'

function ProjectDetail() {
  const { id } = useParams()
  const { setTheme } = useTheme()
  const { project, loading, error } = useProjectDetail(id)

  useEffect(() => {
    setTheme('light')
  }, [setTheme])

  if (loading) {
    return (
      <div className="frontside-page flex min-h-screen flex-col bg-background text-foreground">
        <p className="flex flex-1 items-center justify-center text-muted-foreground">Loading…</p>
      </div>
    )
  }

  if (error || !project) {
    return (
      <div className="frontside-page flex min-h-screen flex-col bg-background text-foreground">
        <div className="flex flex-1 flex-col items-center justify-center px-4">
          <p className="text-destructive text-sm">{error || 'Project not found'}</p>
        </div>
        <Footer />
      </div>
    )
  }

  const detail = normalizePortfolioProject(project)

  return (
    <>
      <ProjectDetailRich
        detail={detail}
        backTo={{ to: '/#projects', label: '← Back to projects' }}
      />
      <Footer />
    </>
  )
}

export default ProjectDetail
